import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const eventObjectsApi = createAsyncThunk(
  "auth/eventObjects",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(
        apiRoutes.publicapiAction('event-objects',1), data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const eventObjectsSlice = createSlice({
  name: "eventObjects",
  initialState: { result: [], loading: false, error: null, message: "", total: 0 },
  extraReducers: (builder) => {
    builder.addCase(eventObjectsApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(eventObjectsApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results?.result??[];
      state.message = action?.payload?.message;
      state.total = action?.payload?.count
    });
    builder.addCase(eventObjectsApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const eventObjectsreducer = eventObjectsSlice.reducer;
